import React, { MouseEventHandler } from "react";
import { Button, type ButtonProps } from "react-bootstrap";

import "./CtaButton.scss";
import CtaButtonBgIcon from "../../icons/CtaButtonBgIcon";
import EllipseIcon from "../../icons/EllipseIcon";
import { ThemeVariant } from "../../../utils/constants/generic-types";

export type CtaButtonVariant = "default" | "fullWidth";
export type CtaButtonSize = "sm" | "md" | "lg";

export interface CtaButtonProps extends Omit<ButtonProps, "variant" | "size"> {
  children: React.ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  variant?: CtaButtonVariant;
  size?: CtaButtonSize;
  className?: string;
  type?: "button" | "submit" | "reset";
  theme?: ThemeVariant;
}

export default function CtaButton({
  children,
  onClick,
  disabled = false,
  variant = "fullWidth",
  size = "md",
  className = "",
  type = "button",
  theme = ThemeVariant.LIGHT,
  ...props
}: CtaButtonProps) {
  const variantClass = variant === "fullWidth" ? "CtaButton--fullWidth" : "";
  const sizeClass = `CtaButton--${size}`;

  return (
    <Button
      type={type}
      className={`CtaButton ${variantClass} ${sizeClass} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      <span className="CtaButton__bg" aria-hidden="true">
        <CtaButtonBgIcon
          size={size}
          className={`CtaButton__BgIcon CtaButton__BgIcon--${theme.toLowerCase()}`}
        />
      </span>
      <span className="CtaButton__ellipse" aria-hidden="true">
        <EllipseIcon
          className={`CtaButton__EllipseIcon CtaButton__EllipseIcon--${theme.toLowerCase()}`}
        />
      </span>

      <span className="CtaButton__content">{children}</span>
    </Button>
  );
}
